import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TabNavComponent } from './tab-nav/tab-nav.component';
import { AnspruchshoehePipe } from './pipes/anspruchshoehe.pipe';
import { KeineBerechtigungComponent } from './components/keine-berechtigung/keine-berechtigung.component';
import { UpsComponent } from './components/ups/ups.component';
import { BezuegestelleFehlerComponent } from './components/bezuegestelle-fehler/bezuegestelle-fehler.component';
import { RouterModule } from '@angular/router';
import { TrimInputDirective } from './directives/trim-input.directive';
import { PxButtonsModule } from './library/px-ui/px-buttons/px-buttons.module';
import { PxDialogsModule } from './library/px-ui/px-dialogs/px-dialogs.module';
import { PxFormsModule } from './library/px-ui/px-forms/px-forms.module';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { OiamOauthComponent } from './components/oiam-oauth/oiam-oauth.component';

@NgModule({
    declarations: [
        TabNavComponent,
        AnspruchshoehePipe,
        KeineBerechtigungComponent,
        UpsComponent,
        BezuegestelleFehlerComponent,
        TrimInputDirective,
        HeaderComponent,
        FooterComponent,
        SpinnerComponent,
        OiamOauthComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PxFormsModule,
        PxDialogsModule,
        PxButtonsModule.forRoot({
            apiHost: '/api/proxy',
            tokenKey: 'download-auth',
        }),
        RouterModule,
    ],
  exports: [
    ReactiveFormsModule,
    FormsModule,
    PxFormsModule,
    PxDialogsModule,
    PxButtonsModule,
    TabNavComponent,
    AnspruchshoehePipe,
    TrimInputDirective,
    HeaderComponent,
    FooterComponent,
    SpinnerComponent,
    OiamOauthComponent
  ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
